import { useConfig } from "@atlassiansox/bxp-content-framework";

type UrlParams = {
    confirmReturnUrl?: string;
    email?: string;
    prompt?: string;
    returnUrl?: string;
    isLogin?: boolean;
};

export const useIdentityUrl = ({
    confirmReturnUrl,
    email,
    prompt,
    returnUrl,
    isLogin
}: UrlParams = {}): string => {
    const { environment } = useConfig();
    const isProduction = environment === "production";

    const baseUrl = isProduction
        ? "id.atlassian.com"
        : "id.stg.internal.atlassian.com";
    const host = isProduction ? "trello.com" : "trellis.coffee";

    // Param passed twice to Identity (in primary URL and encoded in continue/callback URL)
    // See https://hello.atlassian.net/browse/BXPT-1348?focusedCommentId=8509655
    const display = "eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ==";

    const continueParams = new URLSearchParams({ display });

    if (returnUrl) {
        continueParams.append("returnUrl", returnUrl);
    }

    if (confirmReturnUrl) {
        continueParams.append("confirmReturnUrl", confirmReturnUrl);
    }

    if (!isLogin) {
        continueParams.append("createMember", "true");
    }

    const params = new URLSearchParams({
        application: "trello",
        continue: `https://${host}/auth/atlassian/callback?${continueParams}`,
        display
    });

    if (email) {
        params.append("login_hint", email);
    }

    if (prompt) {
        params.append("prompt", prompt);
    }

    const action = isLogin ? "login" : "signup";

    return `https://${baseUrl}/${action}?${params}`;
};
